import React from 'react';
import { Section, Stepper } from './QuoteFields';
import { inr } from './quoteApi';

export const QuoteAddons = ({ addons, setAddon, nights, cooking }) => {
  const n = Math.max(nights, 1);
  return (
    <Section title="Optional add-ons">
      <div className="divide-y divide-gray-100">
        {cooking.enabled && (
          <Stepper testid="quote-addon-cooking" label="Dedicated Cooking Space"
            hint={cooking.villaPicked && cooking.rate > 0 ? `${inr(cooking.rate)}/day · bring your own chef` : 'Price per day depends on villa · select a villa'}
            value={addons.cooking_days} max={n} onChange={(v) => setAddon('cooking_days', v)} />
        )}
        <Stepper testid="quote-addon-maid" label="Maid Service" hint="₹2,000/day · 1 PM – 9 PM serving"
          value={addons.maid_days} max={n} onChange={(v) => setAddon('maid_days', v)} />
        <Stepper testid="quote-addon-bbq" label="BBQ Service (meals)" hint="₹3,000/meal"
          value={addons.bbq_meals} max={10} onChange={(v) => setAddon('bbq_meals', v)} />
        {addons.bbq_meals > 0 && (
          <Stepper testid="quote-addon-bbq-labour" label="Extra BBQ helpers" hint="+₹1,000 per helper per meal"
            value={addons.bbq_extra_labour} max={5} onChange={(v) => setAddon('bbq_extra_labour', v)} />
        )}
        <Stepper testid="quote-addon-bonfire" label="Bonfire (sessions)" hint="₹2,000/session"
          value={addons.bonfire_sessions} max={10} onChange={(v) => setAddon('bonfire_sessions', v)} />
      </div>
    </Section>
  );
};

export default QuoteAddons;
